import { displayBlockTitle, findFamilyRoot, findPersonalRoot } from '@/lib/blocks/constants';
import type { BlockRecord } from '@/lib/blocks/types';

function parentDisplayTitle(
  block: BlockRecord | undefined,
  memberId: string | null,
): string | null {
  if (!block) {
    return null;
  }
  return displayBlockTitle(block, memberId);
}

export function resolveLibrarySource(
  block: BlockRecord,
  familyRootId: string | null,
  privateRootId: string | null,
  byId: Map<string, BlockRecord>,
  memberId: string | null = null,
): { source: 'family' | 'private'; parentTitle: string | null } {
  const parentTitle = block.parentId ? parentDisplayTitle(byId.get(block.parentId), memberId) : null;
  let current: string | null | undefined = block.parentId;

  while (current) {
    if (current === familyRootId) {
      return { source: 'family', parentTitle };
    }
    if (current === privateRootId) {
      return { source: 'private', parentTitle };
    }
    const row = byId.get(current);
    if (!row) {
      break;
    }
    current = row.parentId;
  }

  return { source: 'family', parentTitle };
}

export async function loadWorkspaceRootIds(
  pageRoots: BlockRecord[],
  memberId: string,
): Promise<{ familyRootId: string | null; privateRootId: string | null }> {
  const family = findFamilyRoot(pageRoots);
  const personal = findPersonalRoot(pageRoots, memberId);
  return {
    familyRootId: family?.id ?? null,
    privateRootId: personal?.id ?? null,
  };
}
